import React from "react";
import T from "prop-types";

import { DEFAULT } from "2g-constants/informationTypes";
import { PlaceholderText } from "2g-placeholder";
import Tabs, { Tab } from "2g-tabs";
import { reactComponentType } from "2g-types";

import { useServerMessage } from "b2b/i18n";

export function ZdrojeTabsContent({
  contentRenderer,
  typyZdroju = [],
  loading
}) {
  const message = useServerMessage();

  return loading ? (
    <Tabs>
      {["Žel.infrastruktura", "Haly", "Místnosti", "Ostatní"].map(label => {
        return (
          <Tab
            type={DEFAULT}
            label={<PlaceholderText>{label}</PlaceholderText>}
            key={label}
          />
        );
      })}
    </Tabs>
  ) : (
    <Tabs contentRenderer={contentRenderer}>
      {typyZdroju.map(typZdroje => {
        return (
          <Tab
            type={DEFAULT}
            label={message(typZdroje.typZdroje, "vyznam")}
            key={typZdroje.typZdroje.name}
            data={typZdroje}
          />
        );
      })}
    </Tabs>
  );
}

ZdrojeTabsContent.propTypes = {
  contentRenderer: reactComponentType,
  loading: T.bool,
  typyZdroju: T.array
};

export default React.memo(ZdrojeTabsContent);
